/* @flow */
import React from 'react';
import { debounce } from 'lodash';

import Text from 'components/Text';
import Button from 'components/ButtonDeprecated';
import Glyph from 'components/Glyph';
import SearchBlock from 'components/SearchBlock';
import AccountLinkingComposerSidebarContentList from './AccountLinkingComposerSidebarContentList';
import Image from 'components/Image';

import './styles/AccountLinkingComposerSidebarContent.scss';

type Props = {
  onViewSources: (reloadData: boolean) => void,
  addLinkedContent: (*) => void,
  contentSource: *,
};

type State = {
  query: string,
  queryFailed: boolean,
};

class AccountLinkingComposerSidebarContent extends React.Component<Props, State> {
  state = {
    query: '',
    queryFailed: false,
  };

  performSearch = (rawQuery: string = '') => {
    const query = rawQuery.trim();
    this.setState({
      query,
    });
  };

  handleQueryFailed = () => {
    const { queryFailed } = this.state;

    if (!queryFailed) {
      this.setState({ queryFailed: true });
    }
  };

  handleQueryChange = debounce(this.performSearch, 500, { leading: false, trailing: true });

  render() {
    const { contentSource, onViewSources, addLinkedContent } = this.props;
    const { query, queryFailed } = this.state;

    return (
      <div className="AccountLinkingComposerSidebarContent">
        <div className="AccountLinkingComposerSidebarContent-header">
          <Button
            aria-label="Back"
            className="AccountLinkingComposerSidebarContent-header-backButton"
            level="icon"
            weight="normal"
            size="large"
            onClick={() => onViewSources(queryFailed)}>
            <Glyph name="arrow-left" size="medium" solo />
          </Button>
          <Image
            className="AccountLinkingComposerSidebarContent-header-icon"
            src={contentSource.iconURL}
          />
          <Text
            className="AccountLinkingComposerSidebarContent-header-title"
            align="center"
            size="large"
            color="chalkboard">
            {contentSource.title}
          </Text>
        </div>
        <SearchBlock
          className="AccountLinkingComposerSidebarContent-search"
          label="Search"
          glyphSize="small"
          noBorder
          onDismiss={() => {}}
          onQueryChange={this.handleQueryChange}
          data-test-selector="linked_content_search_input"
        />
        <div className="AccountLinkingComposerSidebarContent-content">
          <AccountLinkingComposerSidebarContentList
            contentSource={contentSource}
            query={query}
            addLinkedContent={addLinkedContent}
            onQueryFailed={this.handleQueryFailed}
          />
        </div>
      </div>
    );
  }
}

export default AccountLinkingComposerSidebarContent;
